import type {
    StoreCollectionSummary,
    StoreTagGroupSummary,
} from "@services/store/commands/cmdGetStorePage";
import type { ContentCatalogFolder } from "@models/contentCatalogFolder.model";
import type { Ad } from "@models/Ad.model";
import type { AdTagMap } from "./storeFilter";

interface StorePageCache {
    orgId: number;
    collections: StoreCollectionSummary[];
    tagGroups: StoreTagGroupSummary[];
    heroSrc: string;
}

interface CollectionDetailCache {
    title: string;
    copyText: string;
    heroSrc: string;
    rootAds: Ad[];
    folders: ContentCatalogFolder[];
    adTags: AdTagMap;
}

let storePage: StorePageCache | null = null;
const collectionDetails = new Map<string, CollectionDetailCache>();
const tagDetails = new Map<string, CollectionDetailCache>();

export const motiStoreCache = {
    getStorePage: () => storePage,
    setStorePage: (value: StorePageCache) => {
        storePage = value;
    },

    getCollection: (id: string) => collectionDetails.get(id) ?? null,
    setCollection: (id: string, value: CollectionDetailCache) => {
        collectionDetails.set(id, value);
    },

    getTag: (id: string) => tagDetails.get(id) ?? null,
    setTag: (id: string, value: CollectionDetailCache) => {
        tagDetails.set(id, value);
    },

    clear: () => {
        storePage = null;
        collectionDetails.clear();
        tagDetails.clear();
    },
};
